<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  title: string
  value: string | number
  subtitle: string
  icon?: string
  tone?: 'emerald' | 'cyan' | 'blue' | 'amber' | 'purple' | 'red'
}>()

defineEmits<{ (e: 'click'): void }>()

const toneClasses = computed(() => ({
  emerald: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-300',
  cyan: 'border-cyan-500/20 bg-cyan-500/10 text-cyan-300',
  blue: 'border-blue-500/20 bg-blue-500/10 text-blue-300',
  amber: 'border-amber-500/20 bg-amber-500/10 text-amber-300',
  purple: 'border-purple-500/20 bg-purple-500/10 text-purple-300',
  red: 'border-red-500/20 bg-red-500/10 text-red-300',
}[props.tone || 'emerald']))

const glyph = computed(() => ({
  job: '▣',
  crew: '👷',
  clock: '◷',
  ticket: '⌑',
  tank: '!',
  application: '▤',
}[props.icon || 'job'] || '•'))
</script>

<template>
  <button
    type="button"
    class="group w-full rounded-2xl border border-slate-700/50 bg-slate-800/50 p-4 text-left shadow-xl shadow-black/5 backdrop-blur-xl transition hover:-translate-y-0.5 hover:border-emerald-500/30"
    @click="$emit('click')"
  >
    <div class="flex items-start justify-between gap-3">
      <div>
        <span class="text-xs font-semibold text-slate-400">{{ title }}</span>
        <strong class="mt-2 block text-2xl font-extrabold text-white">{{ value }}</strong>
        <span class="mt-2 block text-xs text-slate-500">{{ subtitle }}</span>
      </div>

      <div class="grid h-11 w-11 place-items-center rounded-xl border font-black" :class="toneClasses">
        {{ glyph }}
      </div>
    </div>

    <div class="mt-4 h-1.5 overflow-hidden rounded-full bg-slate-700/50">
      <div class="h-full w-2/3 rounded-full bg-gradient-to-r from-emerald-400 to-cyan-400 opacity-70 transition group-hover:w-4/5"></div>
    </div>
  </button>
</template>
